import { DashedTitle, Icon, Row, Tabs } from '@fasstech/middle-design-system';
import { mapIndexed } from '@@serverHelpers/index.mjs';
import { useTabs } from '@@viewCommonComponents/hooks/useTabs.js';
import TabsPagination from '@@viewCommonComponents/TabsPagination.jsx';

const Beneficiaries = ({
  getMiddleText,
  grantees,
  customerCardOptions,
  granteesCardOptions,
  onEdit,
  isProjectEditable
}) => {
  const {
    tabs,
    setTabs,
    setSelectedGrantee,
    updateVisibility,
    displayTabsPagination,
    isButtonDisabled
  } = useTabs({
    grantees,
    getMiddleText,
    defaultMaxVisibleTabs: 5
  });

  return (
    <div className="flex flex-col items-center gap-4">
      <Icon name={'informations_adherent'} size={50} />
      <DashedTitle>
        {getMiddleText('RECAPITULATIF_SOUSCRIPTEUR_TITLE')}
      </DashedTitle>
      <div className="border border-[#E7E7E7] rounded-md w-full">
        <div
          className={
            'w-full flex justify-between items-center p-4 border-b'
          }
        >
          <TabsPagination
            updateVisibility={updateVisibility}
            isButtonDisabled={isButtonDisabled}
            show={displayTabsPagination}
          >
            <Tabs
              items={tabs.tabs}
              selected={tabs.selectedTab}
              onClick={(index) => {
                setTabs({
                  selectedTab: index,
                  tabs: tabs.tabs
                });
                const grantee = grantees[index];
                if (grantee) {
                  setSelectedGrantee(grantee);
                }
              }}
            />
          </TabsPagination>
          {isProjectEditable && <Icon
            name={'circlePen'}
            size={30}
            className={'cursor-pointer'}
            onClick={onEdit}
          />}
        </div>
        {mapIndexed((beneficiary, index) => {
          if (index !== tabs.selectedTab) return null;

          const options =
            index === 0
              ? customerCardOptions
              : granteesCardOptions(beneficiary);

          const leftColumn = options.slice(0, Math.ceil(options.length / 2));
          const rightColumn = options.slice(Math.ceil(options.length / 2));
          return (
            <div className="w-full p-4" key={index}>
              {/* desktop */}
              <div className={'hidden md:flex flex-col gap-4'}>
                <div className="grid grid-cols-2 gap-4">
                  <div className="flex flex-col gap-4 w-full">
                    {leftColumn.map((item, i) => (
                      <Row item={item} index={i} key={`left-${i}`} />
                    ))}
                  </div>
                  <div className="flex flex-col gap-4 w-full">
                    {rightColumn.map((item, i) => (
                      <Row item={item} index={i} key={`right-${i}`} />
                    ))}
                  </div>
                </div>
              </div>

              {/* mobile */}
              <div className="flex flex-col gap-4 md:hidden">
                {options.map((item, i) => (
                  <Row item={item} index={i} key={`mobile-${i}`} />
                ))}
              </div>
            </div>
          );
        }, grantees)}
      </div>
    </div>
  );
};

export default Beneficiaries;
